import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-campaign-management',
  templateUrl: './campaign-management.component.html',
  styleUrls: ['./campaign-management.component.scss']
})
export class CampaignManagementComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
